import { render, staticRenderFns } from "./BreadCrumbs.vue?vue&type=template&id=bc276e94&scoped=true&"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js&"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js&"
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=bc276e94&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc276e94",
  null
  
)

export default component.exports